import { useState } from "react";
import Card from "components/Card";
import { formatAmount } from "utils/utilityFunctions";

interface BannerPropsType {
  employee: EmployeeType;
}

const General = (props: BannerPropsType) => {
  const { employee } = props;

  // State to toggle visibility of total income
  const [isTotalIncomeVisible, setIsTotalIncomeVisible] = useState(false);

  // Function to toggle visibility
  const toggleTotalIncomeVisibility = () => {
    setIsTotalIncomeVisible((prev) => !prev);
  };

  return (
    <Card extra={"w-full h-full p-3 pb-12"}>
      {/* Header */}
      <div className="mt-2 mb-6 w-full">
        <h4 className="px-2 text-xl font-bold text-navy-700 dark:text-white">General Information</h4>
        <div className="mt-2 h-px w-full bg-gray-200 dark:bg-navy-700"></div>
      </div>

      {/* Personal Details Section */}
      <div className="mb-6">
        <h5 className="mb-4 px-2 text-base font-semibold text-gray-700 dark:text-white">
          <i className="fas fa-user-circle mr-2 text-blue-600 dark:text-blue-400"></i>
          Personal Details
        </h5>

        <div className="grid grid-cols-1 gap-4 px-2 md:grid-cols-2">
          <div className="rounded-lg bg-white bg-clip-border px-3 py-4 shadow-sm dark:!bg-navy-700">
            <p className="text-sm text-gray-600 dark:text-gray-400">CNIC</p>
            <p className="text-base font-medium text-navy-700 dark:text-white">{employee.CNIC}</p>
          </div>

          <div className="rounded-lg bg-white bg-clip-border px-3 py-4 shadow-sm dark:!bg-navy-700">
            <p className="text-sm text-gray-600 dark:text-gray-400">Address</p>
            <p className="text-base font-medium text-navy-700 dark:text-white">{employee.address}</p>
          </div>

          <div className="rounded-lg bg-white bg-clip-border px-3 py-4 shadow-sm dark:!bg-navy-700">
            <p className="text-sm text-gray-600 dark:text-gray-400">Phone</p>
            <p className="text-base font-medium text-navy-700 dark:text-white">{employee.phone}</p>
          </div>

          <div className="rounded-lg bg-white bg-clip-border px-3 py-4 shadow-sm dark:!bg-navy-700">
            <p className="text-sm text-gray-600 dark:text-gray-400">Date of Birth</p>
            <p className="text-base font-medium text-navy-700 dark:text-white">{employee.date_of_birth}</p>
          </div>
        </div>
      </div>

      {/* Employment Details Section */}
      <div className="mb-6">
        <h5 className="mb-4 px-2 text-base font-semibold text-gray-700 dark:text-white">
          <i className="fas fa-briefcase mr-2 text-blue-600 dark:text-blue-400"></i>
          Employment Details
        </h5>

        <div className="grid grid-cols-1 gap-4 px-2 md:grid-cols-2">
          <div className="rounded-lg bg-white bg-clip-border px-3 py-4 shadow-sm dark:!bg-navy-700">
            <p className="text-sm text-gray-600 dark:text-gray-400">Company</p>
            <p className="text-base font-medium text-navy-700 dark:text-white">{employee.company || "N/A"}</p>
          </div>
          <div className="rounded-lg bg-white bg-clip-border px-3 py-4 shadow-sm dark:!bg-navy-700">
            <p className="text-sm text-gray-600 dark:text-gray-400">Manager</p>
            <p className="text-base font-medium text-navy-700 dark:text-white">{employee.manager_name || "N/A"}</p>
          </div>
          <div className="rounded-lg bg-white bg-clip-border px-3 py-4 shadow-sm dark:!bg-navy-700 flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600 dark:text-gray-400">Total Wage</p>
              <p className="text-base font-medium text-navy-700 dark:text-white">
                {isTotalIncomeVisible ? formatAmount(employee.total_income) : "****"}
              </p>
            </div>
            <button
              onClick={toggleTotalIncomeVisibility}
              className="text-gray-600 dark:text-gray-400 focus:outline-none"
            >
              <i className={`fas ${isTotalIncomeVisible ? "fa-eye-slash" : "fa-eye"} text-lg`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Banking Details Section */}
      <div>
        <h5 className="mb-4 px-2 text-base font-semibold text-gray-700 dark:text-white">
          <i className="fas fa-university mr-2 text-blue-600 dark:text-blue-400"></i>
          Banking Details
        </h5>

        <div className="grid grid-cols-1 gap-4 px-2 md:grid-cols-2">
          <div className="rounded-lg bg-white bg-clip-border px-3 py-4 shadow-sm dark:!bg-navy-700">
            <p className="text-sm text-gray-600 dark:text-gray-400">Bank</p>
            <p className="text-base font-medium text-navy-700 dark:text-white">
              {employee.bank_detail?.bank_name ?? "N/A"}
            </p>
          </div>

          <div className="rounded-lg bg-white bg-clip-border px-3 py-4 shadow-sm dark:!bg-navy-700">
            <p className="text-sm text-gray-600 dark:text-gray-400">Account Title</p>
            <p className="text-base font-medium text-navy-700 dark:text-white">
              {employee.bank_detail?.account_title ?? "N/A"}
            </p>
          </div>

          <div className="rounded-lg bg-white bg-clip-border px-3 py-4 shadow-sm dark:!bg-navy-700">
            <p className="text-sm text-gray-600 dark:text-gray-400">Account Number</p>
            <p className="text-base font-medium text-navy-700 dark:text-white">
              {employee.bank_detail?.account_number ?? "N/A"}
            </p>
          </div>
        </div>
      </div>
    </Card>
  )
}
export default General
